// "Your note was approved" banner — WITHOUT a notifications system.
// We remember the last bonus_messages value we showed the user
// (localStorage); when the chat opens and the account's bonus is HIGHER,
// a note was approved in the meantime → show the thank-you banner once.
// Decreases (bonus being consumed) just update the snapshot silently.
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

const KEY = 'navarch-last-bonus';

function readStored() {
  try {
    const v = parseInt(window.localStorage.getItem(KEY), 10);
    return Number.isFinite(v) ? v : null;
  } catch {
    return null;
  }
}

function store(value) {
  try {
    window.localStorage.setItem(KEY, String(value));
  } catch {
    // not persistable — the banner may just show again another time
  }
}

export function useBonusBanner() {
  const [banner, setBanner] = useState(false);

  useEffect(() => {
    if (!supabase) return undefined;
    let cancelled = false;
    supabase
      .from('user_plans')
      .select('bonus_messages')
      .single()
      .then(({ data }) => {
        if (cancelled || !data) return;
        const current = data.bonus_messages || 0;
        const stored = readStored();
        if (stored !== null && current > stored) setBanner(true);
        store(current);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    banner,
    dismiss: () => setBanner(false),
    // Called with remaining.bonus after each answer so consumption
    // doesn't later read as "an approval happened".
    syncBonus: value => {
      if (typeof value === 'number') store(value);
    },
  };
}
